/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellLav,
} from '../../../../../../components/UI'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {FC, useEffect, useState, useMemo} from 'react'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {LaundryModel, PointModel, SelectModel} from '../../../../model'
import {getLaundry, getPoint} from '../../../../services'
import {ModalReception} from '../Modal/ModalReception'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {getMasterService} from '../../../../../central/services'
import {getFormatDate} from '../../../../../../util/functions'
import {useCompany, useClient, useSite, useCamp} from '../../../../../central/hooks'
interface FormattedDate {
  fecha: string
  tiempo: string
}
const TableLaundryReception: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    clearSelected,
    pagination,
    updateTable,
    setUpdateTable,
    selectedLav,
    clearTable,
    setClearTable,
  } = useKTable()
  const {currentTabItem, isAllowed} = useLavanderia()
  const {searchValues, clearSearchValues} = useKhipu()
  const [point, setPoint] = useState<SelectModel[]>([])
  const [status, setStatus] = useState<SelectModel[]>([])
  const {companyList, getCompanyList} = useCompany()
  const {clientList, getClientList} = useClient()
  const {siteList, getSiteList} = useSite()
  const {campList, getCampList} = useCamp()
  const [show, setShow] = useState<boolean>(false)

  const getLaundryList = async () => {
    setLoading(true)
    const response = await getLaundry({estado: 'OGE', ...searchValues}, pagination.currentPage)
    const dataInfo = response.data?.data || []
    if (dataInfo.length > 0) {
      dataInfo.forEach((objeto) => {
        let dateCreation = objeto.fechaRegistro ? getFormatDate(objeto.fechaRegistro) : ''
        let dateReception = objeto.fechaRecepcion ? getFormatDate(objeto.fechaRecepcion) : ''
        let dateProgram = objeto.fechaEntregaProgramada
          ? getFormatDate(objeto.fechaEntregaProgramada)
          : ''
        let dateOut = objeto.fechaSalida ? getFormatDate(objeto.fechaSalida) : ''
        objeto.fechaRegistro = dateCreation
          ? (dateCreation as FormattedDate).fecha + ' ' + (dateCreation as FormattedDate).tiempo
          : ''
        objeto.fechaRecepcion = dateReception ? (dateReception as FormattedDate).fecha : ''
        objeto.fechaEntregaProgramada = dateProgram ? (dateProgram as FormattedDate).fecha : ''
        objeto.fechaSalida = dateOut ? (dateOut as FormattedDate).fecha : ''
        return objeto
      })
    }

    setData(dataInfo)
    setLoading(false)
  }
  const getPointList = async () => {
    let obj: PointModel = {
      isCombo: true,
    }
    const response = await getPoint(obj, pagination.currentPage)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setPoint(mappedSites)
  }

  const getStatus = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoLavanderia',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
        codigo: master.codigo,
      }))
      setStatus(mappedMaster)
    } catch (error) {
      setStatus([])
    }
  }

  useEffect(() => {
    getPointList()
    getStatus()
    getCompanyList()
    getClientList()
    getSiteList()
    getCampList()

    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getLaundryList()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination])

  useEffect(() => {
    if (Object.keys(searchValues).length === 0) {
      getLaundryList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValues])

  const columns: Column<LaundryModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} showSelectLav={true} />,
        id: 'selection',
        Cell: ({...props}) => <KTableSelectionCellLav id={props.data[props.row.index].id} />,
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Campamento'
            name='campamentoId'
            selecteable
            data={campList}
          />
        ),
        accessor: 'nombreCampamento',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nro de orden' name='nroOrden' searcheable />
        ),
        accessor: 'nroOrden',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Punto de Lavandería'
            data={point}
            name='puntoId'
            selecteable
          />
        ),
        accessor: 'punto',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha de generación de orden'
            name='fechaRegistro'
            dateable
          />
        ),
        accessor: 'fechaRegistro',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nombre de responsable'
            name='nombreResponsable'
            searcheable
          />
        ),
        accessor: 'nombreResponsable',
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Número de documento'
            name='numeroDocumento'
            searcheable
          />
        ),
        accessor: 'numeroDocumento',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Empresa' name='empresa' searcheable />
        ),
        accessor: 'empresa',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Email' name='email' searcheable />
        ),
        accessor: 'email',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Teléfono' name='telefono' searcheable />
        ),
        accessor: 'telefono',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha de recepción'
            name='fechaRecepcion'
            dateable
          />
        ),
        accessor: 'fechaRecepcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha de entrega Programada'
            name='fechaEntregaProgramada'
            dateable
          />
        ),
        accessor: 'fechaEntregaProgramada',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha de Salida' name='fechaSalida' dateable />
        ),
        accessor: 'fechaSalida',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cantidad prendas'
            name='cantidadPrendas'
            searcheable
          />
        ),
        accessor: 'cantidadPrendas',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Cantidad KG' name='cantidadKG' searcheable />
        ),
        accessor: 'cantidadKG',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Estado' data={status} name='estado' selecteable />
        ),
        accessor: 'estadoNombre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name={'companiaId'}
            selecteable
            data={companyList}
          />
        ),
        accessor: 'nombreCompania',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name={'clienteId'}
            selecteable
            data={clientList}
          />
        ),
        accessor: 'nombreCliente',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Site'
            name={'siteId'}
            selecteable
            data={siteList}
          />
        ),
        accessor: 'nombreSite',
      },
    ],
    [companyList, clientList, siteList, campList, status, point, data],
  )

  useEffect(() => {
    setInitialPagination()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.loadingTable])

  const setInitialPagination = async () => {
    const {data: response} = await getLaundry({}, pagination.currentPage)
    setPagination({
      perPage: 10,
      currentPage: 1,
      totalResults: response.total,
    })
  }

  useEffect(() => {
    if (currentTabItem.loadingTable) {
      clearSelected()
      setUpdateTable(false)
      getLaundryList()
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.loadingTable])

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {}, [data])

  useEffect(() => {
    if (updateTable) {
      clearSelected()
      getLaundryList()
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])
  useEffect(() => {
    if (clearTable) {
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])
  const handleReception = async () => {
    setShow(true)
  }
  const isDisabled = selectedLav.length === 0
  return (
    <>
      <KTCard shadow className='mx-2  w-100'>
        {isAllowed('RECEPCIONAR') && (
          <ButtonWrapper>
            <Button label='Recepción' disabled={isDisabled} onClick={handleReception} />
          </ButtonWrapper>
        )}
        {isAllowed('LISTAR') && (
          <>
            <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
            {loading ? <KTableLoading title='Cargando...' /> : null}
          </>
        )}
      </KTCard>
      <ModalReception
        show={show}
        setShow={setShow}
        arrayId={selectedLav}
        getList={getLaundryList}
      />
    </>
  )
}

const TableLaundryReceptionWrapper = () => {
  return (
    <KTableProvider>
      <TableLaundryReception />
    </KTableProvider>
  )
}

export {TableLaundryReceptionWrapper}
